import { useMediaQuery } from "@uidotdev/usehooks"
import clsx from "clsx"
import BackButton from "components/BackButton"
import Breadcrumbs, { BreadcrumbProps } from "components/Breadcrumbs"
import { useNavigate } from "react-router"
import { breakpoints } from "utils/createBreakpoints"
import { PropsWithClassName } from "utils/types"

type Props = {
  endSlot?: JSX.Element
  showBackButton?: boolean
} & BreadcrumbProps

const PageNavigation = ({
  showBackButton = true,
  endSlot,
  skipLastItem,
  color,
  className,
}: PropsWithClassName<Props>) => {
  const isXs = useMediaQuery(breakpoints.down("xs"))
  const navigate = useNavigate()

  if (isXs && showBackButton)
    return (
      <div className={clsx(className, "flex items-center justify-between")}>
        <BackButton
          onClick={() => navigate(-1)}
          color={"null"}
          className={clsx(color === "light" ? "text-white" : "text-black")}
        />
        {endSlot && endSlot}
      </div>
    )

  return (
    <Breadcrumbs
      skipLastItem={skipLastItem}
      color={color}
      className={className}
    />
  )
}

export default PageNavigation
